import { render, staticRenderFns } from "./CrewEndorseList.vue?vue&type=template&id=65271737&scoped=true&"
import script from "./CrewEndorseList.vue?vue&type=script&lang=js&"
export * from "./CrewEndorseList.vue?vue&type=script&lang=js&"
import style0 from "./CrewEndorseList.vue?vue&type=style&index=0&id=65271737&scoped=true&lang=css&"
import style1 from "./CrewEndorseList.vue?vue&type=style&index=1&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65271737",
  null
  
)

export default component.exports